import { Utente } from "@/models/Utente";
import http from "../http-common";

export const findUtenteById = async (id: number, verified: boolean) => {
  return await http.get("/utente/findOne/" + id + "/" + verified, { withCredentials: verified });
}

export const findUtenteByLogin = async (utente: Utente) => {
  return await http.post("/utente/findByLogin", utente, { withCredentials: true });
}

export const storeProfileImage = async (image: FormData) => {
  return await http.post("/utente/storeImage", image, {
    headers: {
      "Content-Type": "multipart/form-data"
    },
    withCredentials: true
  });
}

export const updateProfilo = async (utente: Utente) => {
  return await http.post("/utente/updateProfile", utente, { withCredentials: true });
}

export const getUtentiByRole = async (role: string) => {
  return await http.get("/utente/getAllByRole/" + role, { withCredentials: true });
}

export const getUtentiByEnte = async (id_ente: number) => {
  return await http.get("/utente/getAllByEnte/" + id_ente, { withCredentials: true });
}

export const getUtentiByRoleAndEnte = async (role: string, idEnte: number | undefined) => {
  return await http.get("/utente/getAllByRoleEnte/" + role + "/" + idEnte, { withCredentials: true });
}

export const findUtenteByUsername = async (username: string, id: number | undefined) => {
  return await http.get("/utente/findByUsername/" + username + "/" + id, { withCredentials: true });
}

export const newUtente = async (utente: Utente) => {
  return await http.post("/utente/new", utente, { withCredentials: true });
}

export const updateUtente = async (utente: Utente) => {
  return await http.post("/utente/update", utente, { withCredentials: true });
}

export const findUtenteDetail = async (id: number) => {
  return await http.get("/utente/findDetail/" + id, { withCredentials: true });
}

export const verifyUtente = async (data) => {
  return await http.post("/utente/verify", data, { withCredentials: true });
}

export const modifyProfileStatus = async (id: number, status: boolean) => {
  return await http.get("/utente/modifyStatus/" + id + "/" + status, { withCredentials: true });
}

export const storeDocuments = async (documents: FormData) => {
  return await http.post("/utente/storeDocuments", documents, {
    headers: {
      "Content-Type": "multipart/form-data"
    },
    withCredentials: true
  });
}

export const getServerDocument = async (url: string) => {
  return await http.post("/utente/getDocument", { url: url }, { withCredentials: true });
}